import React, { Component } from "react";
import { connect } from "react-redux";
import {
    UserManagerV4TableDataWidget,
    AddUserV4Widget,
} from "../../../widgets";
import { StyledCard, StyledContent, StyledHeader } from "../../styles";
import styled from "styled-components";
import { setTabSelection, getUserTypes } from "./actions";
import {
    selectCurrentTab,
    selectUserTypes,
    canUpdate,
    canCreate,
    canDelete,
    selectProfile,
} from "./selectors";
import { Tabs, Tab, Divider, Typography } from "@material-ui/core";
const reducer = "UserManagerV4_reducer";
const tableDataSelectors = UserManagerV4TableDataWidget.createSelectors(
    reducer
);
const addUserWidget = AddUserV4Widget.createSelectors(reducer);

const TabsBar = styled(Tabs)`
    border: 0;
    width: fit-content;
    border-radius: 10px;
    background-color: white;
`;
class UserManager extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        props.getUserTypes();
    }
    render() {
        const { userTypes } = this.props;

        return (
            <>
                <StyledCard>
                    <StyledHeader style={{ borderWidth: 0 }}>
                        <Typography variant="h5">
                            User Manager
                            <AddUserV4Widget.view
                                selectors={addUserWidget}
                                refreshTab={() => {
                                    this.props.setTabSelection("admin");
                                }}
                                currentUserType={this.props.currentTab}
                                canUpdate={this.props.canUpdate}
                                canDelete={this.props.canDelete}
                                canCreate={this.props.canCreate}
                            />
                        </Typography>
                    </StyledHeader>
                    <StyledContent style={{ paddingTop: "0px" }}>
                        <TabsBar
                            classes={{
                                indicator: {
                                    backgroundColor: "#1890ff",
                                },
                            }}
                            value={this.props.currentTab}
                            onChange={(event, value) => {
                                this.props.setTabSelection(value);
                            }}
                            style={{
                                border: 0,
                                root: {
                                    borderBottom: "1px solid #0188cc",
                                },
                                indicator: {
                                    backgroundColor: "#1890ff",
                                },

                                width: "100%",
                            }}
                            scrollable
                            scrollButtons="auto"
                        >
                            {userTypes &&
                                Object.keys(userTypes).map((e) => {
                                    return (
                                        <Tab
                                            style={{
                                                color: "#0188cc",
                                                indicator: {
                                                    backgroundColor: "#0188cc",
                                                },
                                                selected: {
                                                    color: "white",
                                                    backgroundColor: "#0188cc",
                                                },
                                                root: {
                                                    "&:hover": {
                                                        color: "#0188cc",
                                                        opacity: 1,
                                                    },
                                                    "&$tabSelected": {
                                                        color: "#0188cc",
                                                        borderBottom:
                                                            "2px solid #0188cc",
                                                    },
                                                    "&:focus": {
                                                        color: "#0188cc",
                                                        borderBottom:
                                                            "2px solid #0188cc",
                                                    },
                                                },
                                            }}
                                            label={userTypes[e].title}
                                            value={e}
                                        />
                                    );
                                })}
                        </TabsBar>

                        <Divider style={{ width: "100%", marginTop: 24 }} />
                    </StyledContent>
                </StyledCard>
                {this.props.userProfile && (
                    <UserManagerV4TableDataWidget.view
                        selectors={tableDataSelectors}
                        filterByType={this.props.currentTab}
                        canUpdate={this.props.canUpdate}
                        canDelete={this.props.canDelete}
                        canCreate={this.props.canCreate}
                        userProfile={this.props.userProfile}
                        userTypes={userTypes}
                    />
                )}
            </>
        );
    }
}

export default connect(
    (store) => {
        return {
            currentTab: selectCurrentTab(store),
            userTypes: selectUserTypes(store),
            canUpdate: canUpdate(store),
            canCreate: canCreate(store),
            canDelete: canDelete(store),
            userProfile: selectProfile(store),
        };
    },
    { setTabSelection, getUserTypes }
)(UserManager);
